$(document).ready(function(){
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
    //console.log(scroll + "" + height);

    setTimeout(function(){
    if(scroll > height){
     $(".sticky_cart").addClass("show");
      
    }else{
     $(".sticky_cart").removeClass("show");
    }
    },200);
  });  
  $("#btn-sticky-cart").click(function(){
  	$(".product-form__cart-submit").click();
  });

  $('[stickyoptionwrap]').children('.swatch-element').children('.outer_dic').children('label').click(function(){
    var variantId = $(this).attr('variantid');
    var variantPrice = $(this).attr('variantprice');
    var variantCompare = $(this).attr('variantcprice');
    var variantURL = $(this).parents('.swatch-element').attr('variantURL');
    $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
    $('[js-tickycartaddingwpsccs]').attr('productid',variantId);
    $('.product-variant-price-rg').html(variantPrice);
    $('.product-variant-compare_price-rg').html(variantCompare);
    $('[js-stickyinputqtyct]').val(1);
    window.history.replaceState('','',variantURL);
    $('.main-wrpperbox').children('.swatch-element[data-variant="'+variantId+'"]').find('.swatch-quantity').trigger('click');
  });

  $(document).on('click', '[js-tickycartaddingwpsccs]', function(e){
    e.preventDefault();
    var textChnage = $(this);
    var data = $(this).attr('productid'); var qty = $('[js-stickyinputqtyct]').val();
    $(textChnage).children('.add_to_cart').addClass('hide');
    $(textChnage).children('[data-loader]').removeClass('hide');
    $.ajax({
      url:'/cart/add.js',
      type:'POST',
      dataType: 'json',
      data: "quantity="+qty+"&id="+data,
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(response) {
            $('#cartForm').load(' #cartForm');
            $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
            $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
            $('body').addClass('drawer_open');	
          }
        });
      },
      error:function(error){
        $(textChnage).children('.add_to_cart').removeClass('hide');
        $(textChnage).children('[data-loader]').addClass('hide');
      },
      complete: function(){
        $(textChnage).children('.add_to_cart').removeClass('hide');
        $(textChnage).children('[data-loader]').addClass('hide');
      }
    });
  });  

 $(document).on('click', '.qtyplussticky', function(e){
    e.preventDefault();
    var quan = $(this).closest('.cart-para2 ').find('.quantity-input');
    quan.val(+quan.val() + 1);
    var captureqty = parseInt(quan.val());

    if( $('[stickyoptionwrap]').children('.active.swatch-element').length > 0 ){
    var variantQTyml = $('[stickyoptionwrap]').children('.active.swatch-element').children('.outer_dic').children('.variant-selectcv').attr('vaml');
    var variantQTymlcp = $('[stickyoptionwrap]').children('.active.swatch-element').children('.outer_dic').children('.variant-selectcv').attr('vamlcp');
    var totalwp = (variantQTyml*captureqty)/100;
    var totalwpcp = (variantQTymlcp*captureqty)/100;
    $('.product-variant-price-rg').html(totalwp+'€');
    if(totalwpcp > 0){
    $('.product-variant-compare_price-rg').html(totalwpcp+'€');
    }
    }else{
    var variantQTyml = $('.product-variant-price-rg').attr('price');
    var variantQTymlcp = $('.product-variant-compare_price-rg').attr('cprice');
    var totalwp = (variantQTyml*captureqty)/100; 
    var totalwpcp = (variantQTymlcp*captureqty)/100;
    $('.product-variant-price-rg').html(totalwp+'€');
    if(totalwpcp > 0){
    $('.product-variant-compare_price-rg').html(totalwpcp+'€');
    }
    }
  });

  $(document).on('click', '.qtyminussticky', function(e){
    e.preventDefault();
    var quan = $(this).closest('.cart-para2').find('.quantity-input');
    if(quan.val() > 1) quan.val(+quan.val() - 1);
    var captureqty = parseInt(quan.val());
    if( $('[stickyoptionwrap]').children('.active.swatch-element').length > 0 ){
    var variantQTyml = $('[stickyoptionwrap]').children('.active.swatch-element').children('.outer_dic').children('.variant-selectcv').attr('vaml');
    var variantQTymlcp = $('[stickyoptionwrap]').children('.active.swatch-element').children('.outer_dic').children('.variant-selectcv').attr('vamlcp');
    var totalwp = (variantQTyml*captureqty)/100;
    var totalwpcp = (variantQTymlcp*captureqty)/100;
    $('.product-variant-price-rg').html(totalwp+'€');
    if(totalwpcp > 0){
    $('.product-variant-compare_price-rg').html(totalwpcp+'€');
    }
    }else{
    var variantQTyml = $('.product-variant-price-rg').attr('price');
    var variantQTymlcp = $('.product-variant-compare_price-rg').attr('cprice');
    var totalwp = (variantQTyml*captureqty)/100; 
    var totalwpcp = (variantQTymlcp*captureqty)/100;
    $('.product-variant-price-rg').html(totalwp+'€');
    if(totalwpcp > 0){
    $('.product-variant-compare_price-rg').html(totalwpcp+'€');
    }
    }
  });

});